export default {
  ROOT_URL: 'https://cloud-production.conversional.de',
  sentry: 'https://6a99474d26cb411395b5f81a07eba4c8@o236458.ingest.sentry.io/1452146',
  WS_URL: 'soketi-k8s.conversional.de',
  GA_ID: 'UA-4812698-8',
  STUDIO_URL: 'https://studio.conversional.de/',
};
